module.exports = __webpack_public_path__ + "static/img/2017.7881f77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/2017.jpg
// module id = beXc
// module chunks = 51